<script>
  import { ErrorBag } from 'vee-validate'
  import api from '../api'

  export default {
    data() {
      return {
        form: {
          email: '',
          password: ''
        }
      }
    },

    methods: {
      async login() {

        try {
          await this.$validator.validateAll()
        }
        catch (err) {
          return
        }

        try {
          let token = await api.login(this.form.email, this.form.password)
          this.$store.commit('setToken', token)

          let user = await api.apios.get('/api/user')
          this.$store.commit('setUser', user.data)

          this.$router.push('/')
        }
        catch (err) {
          if (err.response.data.error === 'invalid_credentials') {
            this.errors.add('email', 'Wrong email', 'auth')
          }
        }
      }
    }
  }
</script>

<template>
  <section class="hero is-fullheight is-dark is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column is-4 is-offset-4">
            <h1 class="title">
              Login
            </h1>
            <div class="box">
              <form @submit.prevent="login">
                <div class="field">
                  <label class="label">Email</label>
                  <p class="control">
                    <input class="input" name="email" v-model="form.email" type="text" v-validate="'required'" placeholder="jsmith@example.org">
                  </p>
                  <p v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>
                </div>
                <div class="field">
                  <label class="label">Password</label>
                  <p class="control">
                    <input class="input" v-model="form.password" type="password" required placeholder="●●●●●●●">
                  </p>
                </div>
                <div class="field">
                  <p class="control">
                    <button class="button is-primary">Login</button>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
